import 'firebase/auth';
import 'firebase/remote-config';
import { initializeApp, RemoteConfigFetcher } from '@capcenter/firebase-service';

initializeApp(window.location.hostname);

export const remoteConfig: RemoteConfigFetcher = new RemoteConfigFetcher(
	{
		minimumFetchIntervalMillis: 360000,
		fetchTimeoutMillis: 10000,
	},
	{
		mapSearch: true,
	},
);
